import { Chip, styled } from '@mui/material';

export const StyledChip = styled(Chip)(() => ({
  '&.Mui-focusVisible, &[aria-expanded="true"]': {
    borderColor: 'var(--color-grey-darkest)',
  },
  '&[aria-expanded="true"]': {
    backgroundColor: 'var(--color-gray-200)',
  },
  borderRadius: 'var(--border-radius-small)',
}));
